import scrollLock from 'scroll-lock';
import barba from '@barba/core';

export default class ScrollLocking {
	constructor() {

        this.breakpoint = window.matchMedia('(min-width:991px)');

        this.setScrollbarWidth();

		document.addEventListener('disable-scroll', event => {
            if(event.detail) {
                this.lock(event.detail.element);
            } else {
			    this.lock();
            }
		});

		document.addEventListener('enable-scroll', () => {
			this.unlock();
		});
	}

    setScrollbarWidth() {
        const scrollbarWidth = scrollLock.getPageScrollBarWidth();
        document.documentElement.style.setProperty('--scrollbarWidth', scrollbarWidth+'px');
    }

	lock(element) {
        const indexLayout = document.querySelector('[data-shop-index-layout]');
        if(indexLayout) { // Don't lock when it's not even supposed to lock
            if(this.breakpoint.matches) {
			    indexLayout.classList.add('is-locked');
                return;
            }
        }

        if(element) {
            scrollLock.disablePageScroll(element);
        } else {
            scrollLock.disablePageScroll();
        }
	}

	unlock() {
        const indexLayout = document.querySelector('[data-shop-index-layout]');
        if(indexLayout) { // Don't unlock when it's not even supposed to unlock
            if(this.breakpoint.matches) {
			    indexLayout.classList.remove('is-locked');
                return;
            }
        }

		scrollLock.clearQueueScrollLocks();
		scrollLock.enablePageScroll();
	}

}